import { z } from "zod";
export const IntegrationTestStatusEnum = {
    SUCCESS: "success",
    FAILED: "failed",
};
export const integrationTestStatusSchema = z.enum([IntegrationTestStatusEnum.SUCCESS, IntegrationTestStatusEnum.FAILED]);
